<template>
  <div class="settings-wrapper">
    <div class="settings-container">
      <div class="settings-section">
        <h3>Club Settings</h3>
        
        <el-form :model="settingsForm" :rules="rules" ref="settingsForm" label-width="120px">
          <el-form-item label="Status" prop="status">
            <el-select v-model="settingsForm.status" style="width: 100%">
              <el-option label="Active" value="active"></el-option>
              <el-option label="Inactive" value="inactive"></el-option>
              <el-option label="Archived" value="archived"></el-option>
            </el-select>
          </el-form-item> 

          <el-form-item label="Visibility" prop="visibility">
            <el-select v-model="settingsForm.visibility" style="width: 100%">
              <el-option label="Public" value="public"></el-option>
              <el-option label="Private" value="private"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="Join Approval" prop="join_approval">
            <el-switch
              v-model="settingsForm.join_approval"
              active-text="Required"
              inactive-text="Not Required">
            </el-switch>
          </el-form-item>
        </el-form>

        <div class="settings-actions">
          <el-button type="primary" @click="saveSettings">Save Changes</el-button>
        </div>
      </div>

      
    </div>
  </div>
</template>

<script>
import { postRequest } from '@/api/eclub'
import { getUserId, getUserType } from '@/utils/store'

export default {
  name: 'Settings',
  props: {
    clubInfo: {
      type: Object,
      default: () => ({})
    },
    club_id: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      settingsForm: {
        status: 'active',
        visibility: 'public',
        join_approval: false
      },
      rules: {
        status: [
          { required: true, message: 'Please select status', trigger: 'change' }
        ],
        visibility: [
          { required: true, message: 'Please select visibility', trigger: 'change' }
        ]
      }
    }
  },

  created() {
    this.initializeForm()
  },

  methods: {
    initializeForm() {
      this.settingsForm = {
        status: this.clubInfo.status || 'active',
        visibility: this.clubInfo.visibility || 'public',
        join_approval: this.clubInfo.join_approval || false
      }
    },

    async saveSettings() {
      try {
        await this.$refs.settingsForm.validate()
        
        const response = await postRequest('updateClub', {
          id: this.club_id,
          ...this.settingsForm
        })

        if (response.data.code === 0) {
          this.$message.success('Settings updated successfully')
        } else {
          this.$message.error(response.data.message || 'Failed to update settings')
        }
      } catch (error) {
        console.error('Error saving settings:', error)
        this.$message.error('Failed to save settings')
      }
    },

    async handleArchive() {
      try {
        await this.$confirm(
          'Are you sure you want to archive this club? Members will no longer be able to access it.',
          'Archive Club',
          {
            confirmButtonText: 'Archive',
            cancelButtonText: 'Cancel',
            type: 'warning'
          }
        )

        const response = await postRequest('archiveClub', {
          club_id: this.club_id
        })

        if (response.data.code === 0) {
          this.$message.success('Club archived successfully')
          this.$router.push('/home/studentclubs')
        } else {
          this.$message.error(response.data.message || 'Failed to archive club')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('Error archiving club:', error)
          this.$message.error('Failed to archive club')
        }
      }
    },

    async handleDelete() {
      try {
        await this.$confirm(
          'Are you sure you want to permanently delete this club? This action cannot be undone.',
          'Delete Club',
          {
            confirmButtonText: 'Delete',
            cancelButtonText: 'Cancel',
            type: 'danger'
          }
        )

        const response = await postRequest('deleteClub', {
          club_id: this.club_id
        })

        if (response.data.code === 0) {
          this.$message.success('Club deleted successfully')
          this.$router.push('/home/studentclubs')
        } else {
          this.$message.error(response.data.message || 'Failed to delete club')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('Error deleting club:', error)
          this.$message.error('Failed to delete club')
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.settings-container {
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
}

.settings-section {
  background: white;
  padding: 24px;
  border-radius: 8px;
  margin-bottom: 24px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);

  h3 {
    margin-top: 0;
    margin-bottom: 24px;
    font-size: 18px;
    font-weight: 600;
  }
}

.settings-actions {
  margin-top: 24px;
  text-align: right;
}

.danger-zone {
  background: #fff3f3;
  padding: 24px;
  border-radius: 8px;
  border: 1px solid #ffcdd2;

  h3 {
    color: #d32f2f;
    margin-top: 0;
    margin-bottom: 24px;
    font-size: 18px;
    font-weight: 600;
  }

  .danger-actions {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .danger-action {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    background: white;
    border-radius: 4px;
    border: 1px solid #ffcdd2;

    .action-info {
      h4 {
        margin: 0 0 8px 0;
        color: #d32f2f;
      }

      p {
        margin: 0;
        color: #666;
        font-size: 14px;
      }
    }
  }
}

.settings-wrapper {
  min-height: calc(100vh - 64px);
  padding: 20px;
}

:deep(body), :deep(#app) {
  overflow-y: auto;
  height: 100%;
}
</style> 